import { findingsOf } from "../../model/findingsOf";
import { sectionMetrics } from "../../model/sectionMetrics";
import { LaneCard } from "./LaneCard";
import { MetricRows } from "./MetricRows";
import { OtherFindings } from "./OtherFindings";
import type { SectionProps } from "./SectionProps";
import { SoulsSourcesBars } from "./SoulsSourcesBars";

// «Фарм и линия»: линия против соперников (и ровная — тоже), откуда души против сильных
// игроков, метрики фарма строками. Итог линии из находки `lane_result` — в карточке линии,
// отдельной карточкой не повторяется. Разбор без этих подробностей — находки карточками.
export const FarmSection = ({ report, findings }: SectionProps) => {
  const { details } = report;
  const lane = details?.lane ?? null;
  const metrics = sectionMetrics(details, "farm");
  const [laneResult] = findingsOf(findings, "lane_result");
  const hasContent = lane !== null || details?.souls_sources != null || metrics.length > 0;
  return (
    <>
      {lane !== null && (
        <LaneCard
          lane={lane}
          heroId={report.match.hero_id}
          outcome={laneResult?.severity ?? null}
        />
      )}
      {details?.souls_sources != null && <SoulsSourcesBars sources={details.souls_sources} />}
      <OtherFindings
        findings={findings}
        shown={[
          ...(lane !== null ? (["lane_result"] as const) : []),
          ...(metrics.length > 0 ? (["metric"] as const) : []),
        ]}
        hasContent={hasContent}
      />
      <MetricRows metrics={metrics} />
    </>
  );
};
